module.exports = __webpack_public_path__ + "img/4.9cd400d2.jpg";